import { ReactNode, createContext, useContext, useReducer } from "react";

import { InitialContext } from "../types/state/context";
import { MasterArtworkCollectionReducer } from "states/meta-artwork/collections"
import {
  MasterArtworkCollectionActionTypes,
  MasterArtworkCollectionState,
} from "../states/meta-artwork/collections/data.type";

type Context = InitialContext<MasterArtworkCollectionState, MasterArtworkCollectionActionTypes>;

export const MasterArtworkCollectionContext = createContext<Context>({} as Context);

export function MasterArtworkCollectionProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(
    MasterArtworkCollectionReducer.reducer,
    MasterArtworkCollectionReducer.initialState,
  );

  return (
    <MasterArtworkCollectionContext.Provider value={{ state, dispatch }}>
      {children}
    </MasterArtworkCollectionContext.Provider>
  );
}

export const useMasterArtworkCollectionStore = () => useContext(MasterArtworkCollectionContext);
